interface LegacyValidate {
  ERROR_TEMPLATE: string;
  alphanumeric(val?: string): boolean;
  wordCharacter(val?: string): boolean;
  checked(val?: string): boolean;
  numeric(val?: string): boolean;
  decimal(val?: string): boolean;
  decimalWithMaxPrecision(precision: number): (val?: string) => boolean;
  notEmpty(val?: string): boolean;
  notBlank(val?: string): boolean;
  blank(val?: string): boolean;
  email(val?: string): boolean;
  multipleEmails(val?: string): boolean;
  emailorMyEmailAddressToken(val?: string): boolean;
  emailDomain(val?: string): boolean;
  notEmailAddress(val?: string): boolean;
  twitterHandle(val?: string): boolean;
  fileFormat(val?: string): boolean;
  specificFileFormat(extension: string, val?: string): boolean;
  blocklistedExtension(val?: string): boolean;
  imageFormat(val?: string): boolean;
  url(val?: string): boolean;
  urlWithProtocol(val?: string): boolean;
  httpsUrl(val?: string): boolean;
  httpsUrlPortAllowed(val?: string): boolean;
  urlOrTwitterHandle(val?: string): boolean;
  minLength(length: number): (val?: string) => boolean;
  maxLength(length: number): (val?: string) => boolean;
  maxLengthUrlEncoded(length: number): (val?: string) => boolean;
  arrayMinLength(length: number): (val?: string) => boolean;
  maxNumberOfOptions(max: number): (val?: string) => boolean;
  maxOptionCharLength(max: number): (val?: string) => boolean;
  matches<T>(actual: T): (expected?: T) => boolean;
  matchesCaseInsensitive(actual: string): (expected?: string) => boolean;
  matchesRegex(re: RegExp): (val?: string) => boolean;
  doesNotMatchRegex(re: RegExp): (val?: string) => boolean;
  greaterThan<T>(test: T): (actual?: T) => boolean;
  lessThan<T>(test: T): (actual?: T) => boolean;
  inRange<T>(left: T, right: T): (n?: T) => boolean;
  notPresentIn<T>(
    a: Array<T>,
    caseInsensitive?: boolean
  ): (val?: string) => boolean;
  atLeastOneChecked(setId?: string): boolean;
  atLeastOneCheckboxChecked(): boolean;
  maxCheckboxesChecked(max: number, parentFilter?: string): () => boolean;
  matchAllAndReturnFirstGroup(re: RegExp, stringToMatch?: string): string[];
  findTokenCandidates(body?: string): string[];
  emailTemplateTokens(
    validTokens: string[],
    requiredTokens: string[]
  ): (body?: string) => boolean;
  emailTemplateToken(val: string, validTokens: string[]): boolean;
  passes<T>(result: T): () => T;
  dateFormat(value?: string): boolean;
  field(
    selector: string,
    validateFunction: Function,
    message: string,
    allowEmpty?: boolean,
    trim?: boolean,
    setErrorToOtherSelector?: boolean
  ): boolean;
  fieldWithTrim(
    selector: string,
    validateFunction: Function,
    message: string,
    allowEmpty?: boolean
  ): boolean;
  setError(selector: string, message: string): void;
  clearError(selector: string): void;
  isValid(validations: boolean[]): boolean;
  fail(): false;
  scrollToFirstError(): undefined | void;
}

interface LegacyValidator
  extends Omit<
    LegacyValidate,
    | 'ERROR_TEMPLATE'
    | 'field'
    | 'setError'
    | 'clearError'
    | 'isValid'
    | 'scrollToFirstError'
  > {
  new (): LegacyValidator;
  validations: boolean[];
  resetFlags(): void;
  validate(selector: string): this;
  allowEmpty(): this;
  whenPresent(): this;
  whenEnabled(): this;
  withMessage(message: string): this;
  doValidate<T>(validateFunction: Function, args?: Array<T>): boolean;
  isValid(): boolean;
}

// @ts-expect-error - TS2339 - Property 'Validate' does not exist on type 'Window & typeof globalThis'.
export const Validate: LegacyValidate = window.Validate || {};
// @ts-expect-error - TS2740 - Type 'ValidatorStatic' is missing the following properties from type 'LegacyValidator': validations, resetFlags, validate, allowEmpty, and 54 more.
export const Validator: LegacyValidator = window.Validator || (() => {});
